import { EffectStep } from "./effectStep.model";

export type EffectType = "opacity" | "position" | "scale" | "keylight" | "dropshadow";

export class Effect {
  id: string;
  type: EffectType;
  name: string;
  value: number | number[];
  steps: EffectStep[] = [];
  params: any = {};
  keyframeEnabled: boolean;
  defaultValue: number | number[];

  constructor(data: any) {
    this.id = data?.id || crypto.randomUUID();
    this.type = data.type;
    this.name = data?.name || "";
    this.value = data?.value || "";
    this.steps = (data.steps ?? []).map((s: any) =>
      new EffectStep(s)
    ).sort((a: EffectStep, b: EffectStep) => a.time - b.time);
    if (this.steps.length > 1) {
      this.keyframeEnabled = true;
    }
    this.params = data?.params || {};
    this.defaultValue = 0
    this.keyframeEnabled = data?.steps?.length > 1;
  }
}
